import { RenderRequestedEventArgs as RenderRequestedEventArgs_internal } from "./RenderRequestedEventArgs";
import { ensureBool } from "igniteui-react-core";
/**
 * EventArgs class for RenderRequested events.
*
* Use the `RenderRequested` class for RenderRequested events.
*
* ```ts
* <IgrDataChart
* 		dataSource={this.data}
* 		ref={this.onChartRef}
* 		width="100%"
* 		height="100%" >
* <IgrCategoryXAxis name="xAxis" label="Country" />
* <IgrNumericYAxis name="yAxis" minimumValue={0} />
* <IgrColumnSeries name="series1"
* 		xAxisName="xAxis"
* 		yAxisName="yAxis"
* 		valueMemberPath="Coal"
* 		renderRequested= {this.OnRenderRequested}/>
*  </IgrDataChart>
* ```
*
* ```ts
* let series1 = new IgrColumnSeries({ name: "series1" });
* series1.valueMemberPath = "USA";
* series1.title = "USA";
* series1.xAxisName = "xAxis";
* series1.yAxisName = "yAxis";
* series1.renderRequested = this.OnRenderRequested;
*
* public OnRenderRequested =( s:IgrSeries, e:RenderRequestedEventArgs) => {
*
*   }
* ```
*/
var IgrRenderRequestedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrRenderRequestedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
        if (this._initializeAdapters) {
            this._initializeAdapters();
        }
    }
    IgrRenderRequestedEventArgs.prototype.createImplementation = function () {
        return new RenderRequestedEventArgs_internal();
    };
    Object.defineProperty(IgrRenderRequestedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    IgrRenderRequestedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrRenderRequestedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
        if (this._initializeAdapters) {
            this._initializeAdapters();
        }
    };
    Object.defineProperty(IgrRenderRequestedEventArgs.prototype, "animate", {
        /**
         * True if animation is requested.
        *
        * Use the `Animate` property true if the animation is requested.
        *
        * ```ts
        * e.animation = true;
        * ```
        */
        get: function () {
            return this.i.animate;
        },
        set: function (v) {
            this.i.animate = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    return IgrRenderRequestedEventArgs;
}());
export { IgrRenderRequestedEventArgs };
